// extracted by mini-css-extract-plugin
module.exports = {"maximalMobileWidth":"580px","maximalTabletWidth":"1024px","wrapper":"Billing_wrapper__1QiFs","zodiacs":"Billing_zodiacs__yJvsF","copyright":"Billing_copyright__axIhT"};